import React, {  } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';


export default function KodaPracy({kod, setKod} ){
    const { globalSearch } = useZamowienia();
    const handleSubmit = (event) => {
    event.preventDefault(); // Blokuje przeładowanie strony po wciśnięciu Enter
    globalSearch();
  };

  return(
      <form onSubmit={handleSubmit} className={styles.colData}>

      <label className={styles.labelData}> KOD PRACY </label>
      <input className={styles.inputData} style={{width:"100px"}} type="text"
      value={kod}
      onChange={(event) => {
         const re = /^[a-zA-Z0-9_+\sąćęłńóśźżĄĘŁŃÓŚŹŻŚĆŹ.-/-ŠšŽžČčĐđ,!:]+$/;
        setKod(event.target.value);
      }}></input>
    </form>
  );
}